export const GameConfig = {
  width: window.innerWidth,
  height: window.innerHeight,
  backgroundColor: '#f0f0f0',
  physics: {
    default: 'arcade',
    arcade: {
      gravity: { x: 0, y: 0 },
      debug: false
    }
  },
  scale: {
    mode: Phaser.Scale.RESIZE,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: '100%',
    height: '100%',
  },
  render: {
    antialias: true,
    pixelArt: false,
    roundPixels: false
  },
  input: {
    activePointers: 3,
    touch: {
      capture: true
    }
  },
  audio: {
    disableWebAudio: false,
    noAudio: false
  }
} as const;

export const MetroConfig = {
  stationRadius: 15,
  trainSpeed: 200,
  headStartDuration: 10000, // 10 seconds in milliseconds
  runnerSpeed: 250,
  chaserSpeed: 225,
  ticketCost: 50,
  initialCoins: 200,
  challengeCardCooldown: 30000, // 30 seconds in milliseconds
  trainScheduleVariance: 0.2, // 20% random variance in train schedules
} as const; 